import genericTrackIteratively from './generics';
import viewedTrackIteratively from './viewed';

export const TrackIteratively = {
  generic: genericTrackIteratively,
  viewed: viewedTrackIteratively,
};
